<template>

  <SubHeading :home="home" :tabs="tabs" :shorts="false" :currTab="currTab" color="red lighten-3" @active="handleActive" />

  <!-- breadcrumbs -->
  <nav class="sba-collection-breadcrumb private-add-breadcrumb z-depth-0">
    <div class="container nav-wrapper">
      <div class="sba-collection-breadcrumb-row">
        <router-link to="/" class="breadcrumb sba-collection-crumb teal-text">
          <i class="material-icons">home</i>
          <span>Dashboard</span>
        </router-link>
        <i class="material-icons sba-collection-crumb-separator">chevron_right</i>
        <router-link to="/private" class="breadcrumb sba-collection-crumb teal-text">
          <span>HMO Clients Home</span>
        </router-link>
        <i class="material-icons sba-collection-crumb-separator">chevron_right</i>
        <span class="breadcrumb sba-collection-crumb blue-grey-text">
          <span>Add Client</span>
        </span>
        <span class="sba-collection-context">Client Onboarding</span>
      </div>
    </div>
  </nav>

  <div id="top"></div>

  <div class="container client-add-page-shell">
    <div class="client-add-workbench sba-slide-in">
      <div class="client-add-head">
        <div class="client-add-title-block">
          <label class="active teal-text">Client Desk</label>
          <h5>Add Client</h5>
          <p>Capture the client profile, confirm operating settings, and complete the onboarding review.</p>
        </div>
      </div>

      <section class="client-add-body">
        <ProfileDiv :cat="cat" :newClient="newClient" @next="handleNext" v-if="next == 'start'" />
        <StatusDiv :cat="cat" :newClient="newClient" @next="handleNext" @back="handleBack" v-if="next == 'status'" />
        <SettingsDiv :cat="cat" :newClient="newClient" @next="handleNext"  @back="handleBack" v-if="next == 'settings'" />
        <ReviewDiv :cat="cat" :newClient="newClient" @next="handleNext" @back="handleBack" v-if="next == 'review'" />
        <PolicyDiv :cat="cat" :newClient="newClient" @next="handleNext" v-if="next == 'policy'" />
      </section>
    </div>
  </div>
</template>

<script>
import { ref, onMounted, watchEffect } from "vue";
import { useRouter } from "vue-router";
import useModuleNavigation from "@/composables/useModuleNavigation";
import SubHeading from "@/components/HeaderSubDiv.vue";
import ProfileDiv from "@/components/client/onboard/ProfileOnboardComponent.vue";
import StatusDiv from "@/components/client/onboard/StatusOnboardComponent.vue";
import SettingsDiv from "@/components/client/onboard/SettingsOnboardComponent.vue";
import ReviewDiv from "@/components/client/onboard/ReviewOnboardComponent.vue";
import PolicyDiv from "@/components/client/onboard/PolicyOnboardComponent.vue";
import M from "materialize-css";

export default {
  name: "privateClientAdd",
  components: { SubHeading, ProfileDiv, ReviewDiv, StatusDiv, SettingsDiv, PolicyDiv },
  setup() {
    const home = ref(null);
    const cat = ref("hmo");
    const next = ref("start");
    const newClient = ref({});
    const currTab = ref(null);
    const tabs = ref([]);

    // vue router
    const router = useRouter();
    const { routeToTab } = useModuleNavigation();

    // start
    onMounted(() => {
      // page name
      document.title = "Add (Private) Client";
    });

    // menu
    onMounted(() => {
      // load tab
      tabs.value.push({ id: 1, name: "Clients", title: "All", icon: "arrow_back", url: "private", hash: null, });
      tabs.value.push({ id: 2, name: "Clients", title: "View", icon: "visibility", url: "private", hash: "#view" });
      tabs.value.push({ id: 3, name: "Clients", title: "Add Client", icon: null, url: null, hash: null, });

      // set default
      currTab.value = tabs.value.find(x => x.title.includes("Add"));
      // set home
      home.value = tabs.value.find(x => x.id === 1);
    });

    // handle curr status
    const handleActive = (tab) => {
      routeToTab(tab, { replace: !tab?.url });
    };

    // Title
    watchEffect(() => {
      if (newClient.value) {
        // load title
        setTimeout(() => {
          var elems = document.querySelectorAll(".tooltipped");
          M.Tooltip.init(elems, {});
        }, 2000);
      }
    });

    // UI modification
    const maxRule = (text) => {
      let maxLength = 15;
      if (text.length > maxLength) {
        return ` ${text.substring(0, maxLength)} ... `;
      } else {
        return ` ${text} `;
      }
    };

    // handle next
    const handleNext = (val) => {
      if (val.id == "profile") {
        // save profile
        newClient.value.profile = val.value;
        // next
        next.value = "status";
      } else if (val.id == "status") {
        // save status
        newClient.value.status = val.value;
        // next
        next.value = "settings";
      } else if (val.id == "settings") {
        // save status
        newClient.value.settings = val.value;
        // next
        next.value = "review";
      } else if (val.id == "review") {
        // account is created in review
        // save created
        newClient.value.created = val.value;
        //next
        next.value = "policy";
      } else if (val.id == "policy") {
        // finish
       router.push({ name: "privateView", params: { id: newClient.value.created.id } });
      }
       // top
       if (val.id != "policy") {
       router.push({ hash: "#top" });
       }
    };

    // handle next
    const handleBack = (val) => {
      if (val.id == "profile") {
        // no back button
      } else if (val.id == "status") {
        // back
        next.value = "start";
      } else if (val.id == "settings") {
        // back
        next.value = "status";
      } else if (val.id == "review") {
        // back
        next.value = "settings";
      } else if (val.id == "policy") {
        // no back button
      }
       // top
       router.push({ hash: "#top" });
    };


    return {
      home,
      handleActive,
      currTab,
      tabs,
      cat,
      next,
      maxRule,
      handleNext,
      handleBack,
      newClient,
    };
  },
};
</script>

<style scoped>
.private-add-breadcrumb {
  background: #fafafa !important;
  position: relative;
}

.private-add-breadcrumb::after {
  background: #c4d3d9;
  bottom: 0;
  content: "";
  height: 1px;
  left: 0;
  pointer-events: none;
  position: absolute;
  right: 0;
}

.client-add-page-shell {
  margin-top: -14px;
  padding-bottom: 44px;
  padding-top: 0;
  position: relative;
  z-index: 1;
}

.client-add-workbench {
  color: #263238;
}

.client-add-head,
.client-add-body,
.client-add-workbench :deep(.card),
.client-add-workbench :deep(.card-panel),
.client-add-workbench :deep(.onboard-action-row) {
  animation: sbaSlideIn var(--sba-slide-duration, 260ms) ease-out both;
}

.client-add-head {
  background: #ffffff;
  border: 1px solid #c4d3d9;
  border-radius: 6px 6px 0 0;
  box-shadow: 0 12px 20px -18px rgba(38, 50, 56, 0.55);
  margin-bottom: 0;
  padding: 24px 26px;
  position: relative;
  z-index: 2;
}

.client-add-head::before {
  border: 1px solid #c4d3d9;
  border-bottom: 0;
  border-radius: 7px 7px 0 0;
  content: "";
  height: 18px;
  left: -1px;
  pointer-events: none;
  position: absolute;
  right: -1px;
  top: -1px;
  z-index: 1;
}

.client-add-title-block {
  position: relative;
  z-index: 2;
}

.client-add-title-block h5 {
  color: #263238;
  font-weight: 700;
  margin: 4px 0 0;
}

.client-add-title-block p {
  color: #607d8b;
  line-height: 1.45;
  margin: 6px 0 0;
  max-width: 760px;
}

.client-add-body {
  background: #f5f7f8;
  border: 1px solid #c4d3d9;
  border-radius: 0 0 6px 6px;
  border-top: 0;
  box-shadow: 0 18px 34px -31px rgba(38, 50, 56, 0.75);
  padding: 22px 18px 18px;
  position: relative;
  z-index: 1;
}

.client-add-body :deep(form) {
  margin: 0;
}

.client-add-body :deep(.section) {
  padding-bottom: 0.55rem;
  padding-top: 0.55rem;
}

.client-add-body :deep(.card),
.client-add-body :deep(.card-panel) {
  background: #ffffff !important;
  border: 1px solid #dde6e9;
  border-radius: 6px;
  box-shadow: none;
}

.client-add-body :deep(.card) {
  overflow: visible;
}

.client-add-body :deep(.card-content) {
  border-bottom: 1px solid #edf2f3;
  padding: 18px 22px 14px;
}

.client-add-body :deep(.card-title) {
  align-items: center;
  color: #00695c !important;
  display: flex;
  font-size: 1.08rem;
  font-weight: 700;
  gap: 10px;
  line-height: 1.25;
}

.client-add-body :deep(.card-title .material-icons.right) {
  margin-left: auto;
}

.client-add-body :deep(.card-panel) {
  margin: 14px 18px;
  padding: 18px 20px;
}

.client-add-body :deep(.card-panel .row:last-child),
.client-add-body :deep(.card-panel p:last-child) {
  margin-bottom: 0;
}

.client-add-body :deep(.chip) {
  background: #e8f5f3;
  border: 1px solid #b8dfda;
  color: #00695c;
  font-size: 0.75rem;
  font-weight: 700;
  height: 24px;
  line-height: 22px;
}

.client-add-body :deep(.input-field) {
  margin-bottom: 0.55rem;
  margin-top: 0.85rem;
}

.client-add-body :deep(input:not([type]):focus:not([readonly])),
.client-add-body :deep(input[type=text]:not(.browser-default):focus:not([readonly])),
.client-add-body :deep(input[type=email]:not(.browser-default):focus:not([readonly])),
.client-add-body :deep(input[type=number]:not(.browser-default):focus:not([readonly])) {
  border-bottom-color: #00897b;
  box-shadow: 0 1px 0 0 #00897b;
}

.client-add-body :deep(.autocomplete-content.dropdown-content) {
  z-index: 20;
}

.client-add-body :deep(.onboard-action-row) {
  align-items: center;
  border-top: 1px solid #edf2f3;
  display: flex;
  gap: 12px;
  justify-content: space-between;
  margin: 6px 18px 0;
  padding: 18px 0 4px;
}

.client-add-body :deep(.onboard-action-row.is-single) {
  justify-content: flex-end;
}

.client-add-body :deep(.onboard-action-row.is-policy) {
  justify-content: flex-start;
}

.client-add-body :deep(.onboard-action-row .modal-trigger:last-child) {
  margin-left: auto;
}

.client-add-body :deep(.section.center),
.client-add-body :deep(.section > .row) {
  margin-bottom: 0;
}

.client-add-body :deep(.btn-large) {
  border-radius: 5px;
  box-shadow: 0 10px 18px -16px rgba(38, 50, 56, 0.8);
  font-size: 0.84rem;
  font-weight: 700;
  letter-spacing: 0;
  text-transform: none;
}

.client-add-body :deep(.btn-large.blue) {
  background: #00796b !important;
}

.client-add-body :deep(.btn-large.blue:hover) {
  background: #00695c !important;
}

.client-add-body :deep(.btn-large.black) {
  background: #37474f !important;
}

.client-add-body :deep(.btn-large.black:hover) {
  background: #263238 !important;
}

.pointer {
  cursor: default;
}

.custom-nav {
  height: 15px;
}

/* .nav-extended .nav-wrapper {
  padding: 0 20px;
} */

.brand-logo {
  font-weight: 300;
  font-size: 5rem;
}

.nav-wrapper ul li a {
  font-weight: 400;
  padding: 0 15px;
}

.nav-content {
  min-height: 20px;
}

@media only screen and (max-width: 600px) {
  .client-add-head {
    padding: 20px;
  }

  .client-add-title h5 {
    font-size: 1.35rem;
    line-height: 1.25;
  }

  .client-add-body {
    padding: 18px 12px;
  }

  .client-add-body :deep(.card-content),
  .client-add-body :deep(.card-panel) {
    margin-left: 0;
    margin-right: 0;
    padding-left: 16px;
    padding-right: 16px;
  }

  .client-add-body :deep(.onboard-action-row) {
    align-items: stretch;
    flex-direction: column;
    margin-left: 0;
    margin-right: 0;
  }

  .client-add-body :deep(.onboard-action-row .modal-trigger:last-child) {
    margin-left: 0;
  }

  .client-add-body :deep(.btn-large),
  .client-add-body :deep(.modal-trigger) {
    width: 100%;
  }
}

@media (prefers-reduced-motion: reduce) {
  .client-add-head,
  .client-add-body,
  .client-add-workbench :deep(.card),
  .client-add-workbench :deep(.card-panel),
  .client-add-workbench :deep(.onboard-action-row) {
    animation: none;
  }
}
</style>
